// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  height: 100%;
  min-height: 0;
  width: 100%;
}

app-audit-questionnaire {
  width: 100%;
}
`, "",{"version":3,"sources":["webpack://./projects/cemsys/src/app/lab-audit-checklist/tabs/cement-job-tab/cement-job-tab.component.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,YAAY;EACZ,aAAa;EACb,WAAW;AACb;;AAEA;EACE,WAAW;AACb","sourcesContent":[":host {\n  display: block;\n  height: 100%;\n  min-height: 0;\n  width: 100%;\n}\n\napp-audit-questionnaire {\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
